import ScrollableTabsButtonAuto from "./Tabs";

export default ScrollableTabsButtonAuto;